import {
  get,
  post
} from "@/utils/request";
import axios from "axios";
//平台配置
export const configuration = params => post(`/sys-server/open-api/h5/app/bottom`, params);
//政策法规
export const getPolicyList = params => post(`/sys-server/open-api/h5/policy/page`, params);
//政策法规详情
export const getPolicyDetail = params => post(`/sys-server/open-api/h5/policy/detail/` + params);
// 新闻资讯
export const getNewsList = parmas => post(`/sys-server/open-api/h5/news/page`, parmas);

// 81主站新闻 网站公告
export const gethostList = parmas => get(`/news-server/open-api/h5/news/hot`, parmas);

//政策法规详情
export const getNewsDetail = params => post(`/sys-server/open-api/h5/news/detail/` + params);
//政策法规详情 点赞
export const getpraise = params => get(`/sys-server/open-api/h5/policy/praise/` + params);
//新闻资讯详情点赞
export const getnewsPraise = params => get(`/sys-server/open-api/h5/praise/` + params);

// //山西活动媒体报道 --- 页面已不用
/*
*报502 */
export const getReportList = params => post(`/api/bc/news/report/page`, params);
/*
*报502 */
// 山西活动媒体报道 首页3个
export const getReportTop = params => get(`/api/bc/news/report/top`, params);

//首页
//轮播图
export const getImgApi = params => post('/sys-server/open-api/h5/image/page?' + Math.random() / 9999, params);

// logo
export const logoList = params => get('/sys-server/open-api/job/logo_list?' + Math.random() / 9999, params);


//求职招聘：职位、公司
//城市选择（省、市）
// export const getCityDataApi = () => get('/api/ff/city/tree');
export const getCityDataApi = parmas => get(`/sys-server/open-api/h5/level2/tree`, parmas);
// 地区 直辖市的地区有3级
export const level3tree = parmas => get(`/sys-server/open-api/h5/current/level3/tree  `, parmas);

// 获取类别（行业：parentValue=INDUSTRY_CATEGORIES 工作经验：parentValue=WORK_EXPERIENCE  学历：parentValue=educationLevel 企业性质：parentValue=COMPANY_NATURE  ）
export const getTpyeApi = params => get('/sys-server/api/sys/macro/list', params);
//职位列表
export const getJobListApi = params => post('/search-server/open-api/job_search/list', params);
//职位详情
export const getJobDetailsApi = parmas => post('/sys-server/open-api/job/h5/details', parmas);

//公司详情
export const companyDetail = parmas => get(`/sys-server/open-api/job/company/details/` + parmas);
// 职位列表
export const jobList = parmas => post(`/search-server/open-api/job_search/list`, parmas);
// 标签列表

export const tagList = parmas => get(`/sys-server/open-api/h5/tag/list`,parmas);

// 热门招聘设置获取
export const HotRecruitList = () => get(`/sys-server/open-api/h5/listHotRecruit`)
// 获取天津职位 企业数量
export const mapStatistics = () => get(`/sys-server/open-api/bsp/mapStatistics`);
// 内蒙统计数据
export const getTagAllAndCurrentDayDate = parmas => get(`/sys-server/open-api/bsp/getTagAllAndCurrentDayDate`, parmas);
export const getWater = parmas => get(`/sys-server/open-api/water/newGet`, parmas);
// 内蒙统计职位数据
export const jobFairCompany = parmas => post(`/sys-server/open-api/h5/jobFairCompany/page`, parmas);
// 获取天津职位 企业数量
export const mapProportion = parmas => get(`/sys-server/open-api/h5/industry_proportion`, parmas);
// 获取天津职位 热门岗位
export const mapHotJob = () => get(`/sys-server/open-api/bsp/hotJob`);
// 获取天津职位 岗位类别
export const mapJobType = () => get(`/sys-server/open-api/bsp/jobType`);


// WEBPACK FOOTER //
// ./src/api/getData.js